export const compositionMaterialType = {
    WALL_PANEL: "Стеновая панель",
    BODY_TOP: "Верх корпуса",
    BODY_BOTTOM: "Низ корпуса",
    FRONT_TOP: "Верх фасада",
    FRONT_BOTTOM: "Низ фасада",
    TABLE_TOP: "Столешница",
    BACK_TOP: "Задняя стенка (верх)",
    BACK_BOTTOM: "Задняя стенка (низ)",
}
